import styles from "../../pages/DashBoard/AllUsers.module.css"
import tableStyles from "./UserTable.module.css"
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { BASE_URL, SEND_ONBOARD_EMAIL, MARK_DROP, ACTIVATE, USER_TOKEN, USER_TYPES, VERIFIER_DROP, VERIFIER_ACTIVE, SEND_ONBOARD_EMAIL_VERIFIER, SEND_WELCOME_EMAIL } from '../../Utils/constant'
import API from '../../ApiConfig'
import cogoToast from 'cogo-toast-react-17-fix'

import { Logger, _ToNormal, setDate } from "../../Utils/helper";
import Loader from "../Loader";
import { useSelector } from "react-redux";
import Icon from "react-icons-kit"


import { arrowRight } from "react-icons-kit/feather/arrowRight"
const UserTable = ({ activeTab, list, refreshList, setSortBy, sortBy, getCount }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [drop, setDrop] = useState(false)
  const [accordian, setaccordian] = useState()
  const [initialLoad, setInitialLoad] = useState(true);
  const [sortByIssuer, setSortByIssuer] = useState(true)
  // const status=["ONBOARDED","Link_Generated","Mark Dropped"]
  // console.log(list);
  const[filteredItems,setFilterItems]=useState([]);
  const User=useSelector(state=>state.User)
  
  useEffect(() => {
    setFilterItems(list);
  }, [list])
  const SortList = (sort) => {
    let direction = "asc";

    if (sortBy.key === sort && sortBy.direction === "asc") {
        direction = "desc";
    }
    const newSortBy = { key:sort, direction }
    setSortBy(newSortBy)
    
  };
  // console.log("filtered Items:",filteredItems);

  function handleNavigate(url) {
    navigate(url)
  }
  function resendLink(email,user_type, company_name) {
    // debugger
    let apiData={
      email,
      company_name,
      ...(user_type=="Verifier"&&{category:"3"})
    }
    let resendLinkAPI = user_type === "Verifier"? SEND_ONBOARD_EMAIL_VERIFIER: SEND_ONBOARD_EMAIL;
    setLoading(true)
    API.post(resendLinkAPI, apiData)
      .then(res => {
        setLoading(false)
        if (res.status === 200) {
          cogoToast.success(res.data.message)
          setTimeout(() => window.location.reload(), 1000)
        }
      })
      .catch(err => {
        setLoading(false)
        cogoToast.error(err.response.data.message)
      })

  }

  function markDrop(email, user_type) {
    setLoading(true)
    let URL = user_type === 'Verifier' ? VERIFIER_DROP : MARK_DROP;
    API.get(URL + email)
      .then(data => {
        if (data.data.status === 200) {
          cogoToast.success("EMAIL ID " + email + " is Dropped");
          refreshList();
          getCount()
        } else {
          cogoToast.error("Unable to drop " + email);
        }
      })
      .catch(err => {
        cogoToast.error(err.message);
        setLoading(false)
      })
}

function markActivate(email, user_type) {
  setLoading(true);
  setaccordian();
  let URL = user_type === 'Verifier' ? VERIFIER_ACTIVE : ACTIVATE;
  API.get(URL + email)
    .then(data => {
      if (data.data.success === true) {
        cogoToast.success("EMAIL ID " + email + " is Activated");
        refreshList();
        getCount()
      } else {
        cogoToast.error("Unable to activate " + email);
      }
    })
    .catch(err => {
      cogoToast.error(err.message);
      setLoading(false);
    })
}
const handleSendEmail=(userId)=>{
  setLoading(true);
  API.post(SEND_WELCOME_EMAIL,{user_id:userId})
  .then(data=>{
    if(data.status==200){

      cogoToast.success(data.data.data.message)
      setLoading(false)

    }
    
  })
  .catch(err=>{

    cogoToast.error(err.response.data.message)
    setLoading(false)
    
  })
}
function isaccordianOpen(event, index) {
    if (!Array.from(event.target.classList).some(className => className.includes('button'))) {
      accordian === index ? setaccordian() : setaccordian(index);
    } else {
      setaccordian();
    }
}

const ButtonBase = (props) => {
  let { id, email, state, user_type,registration_url, send_email, user_id, company_name } = props;
  const token=registration_url&&registration_url.split('/').pop()
  
  
  let URL = `/company/${USER_TYPES[user_type]}/${id}/profile`;
  if (state === "ONBOARDED" && User.user_type=="Super Admin") {
    return (
      <div className={tableStyles.buttonBase}>
        <div className={tableStyles.button + " " + tableStyles.view} onClick={() => handleNavigate(URL)}>
          View
          <Icon icon={arrowRight} size={18}/>
        </div>
        <div className={tableStyles.button + " " + tableStyles.drop} onClick={() => markDrop(email, user_type)}>
          Mark Dropped
          {/* {drop?<>Dropping</>:<>Mark Dropped</>} */}
        </div>
        {User.user_type=="Super Admin" && send_email==true ? <div className={tableStyles.button + " " + tableStyles.view} onClick={()=>handleSendEmail(user_id)}> Send Email </div>:null}
      </div>
    );
  } else if (state === "MARK_DROPPED" && User.user_type=="Super Admin") {
    return (
      <div className={tableStyles.buttonBase}>
        <div className={tableStyles.button + " " + tableStyles.disabled}>
          View
        </div>
        <div className={tableStyles.button + " " + tableStyles.activate} onClick={() => markActivate(email, user_type, company_name)}>
          Reactivate
        </div>
      </div>
    );
  } else if (state === "LINK_EXPIRED") {
    return (
      <div className={tableStyles.buttonBase}>
        {User.user_type=="Super Admin"&&
        <div className={tableStyles.button + " " + tableStyles.disabled}>
          View
        </div>}
        <div className={tableStyles.button + " " + tableStyles.resend} onClick={() => resendLink(email,user_type,company_name)}>
          Resend Link
        </div>
      </div>
    );
  } else {
    return (
      <div className={tableStyles.buttonBase}>
        {User.user_type=="Super Admin"&&
        <div className={tableStyles.button + " " + tableStyles.disabled}>
          View
        </div>}
        {state=="LINK EXPIRED" &&
        <div className={tableStyles.button + " " + tableStyles.disabled}>
          Resend Link
        </div>}
        {User.user_type=="Super Admin" &&<div className={tableStyles.button + " " + tableStyles.view} onClick={()=>setTimeout(navigate(`/app/registration/${token}`),5000)}>
          Register
        </div>}
      </div>
    );
  }
};

  const AccordianData = ({ Items }) => {
    if (Items.length < 1) {
      return (
        <td className={styles.tablescell} colspan="7">
          <div className={tableStyles.th}>No Items</div>
        </td>
      )
    }
    return (
      <tr className={styles.chevronSortTableCell5}>
        <td className={styles.tablescell} colspan="7">
          <div className={tableStyles.accordianItems}>
          {Items.map((item) => (
            <div className={tableStyles.accordianItem}>
              <div className={tableStyles.header}>
                <div className={tableStyles.image}>
                  <img src='/profilecardoutline.svg' style={{width:'-webkit-fill-available'}}></img>
                </div>
                <div className={tableStyles.title}>
                  <span className={tableStyles.heading}>{_ToNormal(item.document_name)}</span>
                  <span className={tableStyles.status}>{item.document_status}</span>
                </div>
              </div>
              <div>
                {
                item.document_status == "Done" || item.document_status == "Issued"  ?
                <button className={tableStyles.done}>View Document</button> 
                : item.document_status == "Inactive" ?
                  <button className={tableStyles.inactive}>Activate Document</button>
                  :
                  <button className={tableStyles.icon}>Continue Editing</button>
              }
              </div>

              {/* {
                item.document_status == "Done" || item.document_status == "Issued"  ?
                  <div className={tableStyles.done}>
                    <span className={tableStyles.link}>{item.document_status}</span>
                  </div> :
                  item.document_status == "Inactive" ?
                    <div className={tableStyles.inactive}>
                      <span className={tableStyles.link}>Inactive</span>
                    </div> :
                    <div className={tableStyles.icon}>
                      <span className={tableStyles.link}>Pending</span> 
                    </div>
              } */}
            </div>
          ))}
          </div>
        </td>
      </tr>
    )
    // return (<tr className={styles.chevronSortTableCell}>
    //   <td className={styles.tablescell} colspan="7">
    //     <table className={tableStyles.table} style={{ width: "fit-content" }}>
    //       <tr className={tableStyles.tr}>
    //         <th className={tableStyles.th}>Items</th>
    //         <th className={tableStyles.th}>Status</th>
    //       </tr>
    //       {Items.map((item) => (
    //         <tr key={item.document_name} className={tableStyles.tr}>

    //           <td className={tableStyles.td}>{_ToNormal(item.document_name)}</td>
    //           <td className={tableStyles.td} style={{ display: 'flex' }}>
    //             {
    //               item.document_status == "Done" || item.document_status == "Issued"  ?
    //                 <div className={tableStyles.done}>
    //                   <span className={tableStyles.link}>{item.document_status}</span>
    //                 </div> :
    //                 item.document_status == "Inactive" ?
    //                   <div className={tableStyles.inactive}>
    //                     <span className={tableStyles.link}>Inactive</span>
    //                   </div> :
    //                   <div className={tableStyles.icon}>
    //                     <span className={tableStyles.link}>Pending</span> 
    //                   </div>}
    //           </td>
    //         </tr>
    //       ))}
    //     </table>
    //   </td>
    // </tr>)
  }

  useEffect(()=>{
    if(list[0]!=1){
      setLoading(false)
    }
    else{
      setLoading(true)
    }
  },[list])
  
  useEffect(() => {
    if (!loading) {
        setInitialLoad(true);
        const timer = setTimeout(() => setInitialLoad(false), 500);
        return () => clearTimeout(timer);
    }
}, [loading]);
  const TableData = ({ item, index , key}) => {
    let style = {}
    if (accordian == index) {
      style = { background: 'var(--gray-100)' }
    }
    let Docstate = {
      backgroundColor: "#E1EFFE",
      color: "var(--primary-700)"
    }
    
    if (item.state == "MARK_DROPPED") {
      Docstate = {
        color: "#E02424",
        backgroundColor: "#FDE8E8"
      }
    }
    else if (item.state == "LINK_EXPIRED") {
      Docstate = {
        color: "#723B13",
        backgroundColor: "#FDF6B2"
      }
    }
    return (
        <>
        <tr key={key} className={`${styles.chevronSortTableCell} ${initialLoad ? styles.fadeIn : ''}`} onClick={e => item.user_type === 'Issuer' ? isaccordianOpen(e, index) : null} style={loading?null:{ animationDelay: `${index * 0.1}s` }}>
                <td className={styles.tablescell}>
                    {item.user_type === 'Issuer' ? (
                        <div className={styles.checkbox}>
                            {accordian == index ? (
                                <img src="/angledown.svg" style={{ transform: 'rotate(180deg)' }} />
                            ) : (
                                <img src="/angledown.svg" />
                            )}
                        </div>
                    ) : null}
                </td>
                <td className={styles.tablescell}>
                    <div className={styles.textCell}>
                        {loading ? <div className="shimmer"></div> : (item?.name ? item?.name : 'N/A')}
                    </div>
                </td>
                <td className={styles.tablescell}>
                <div className={styles.textCell}>
                        {loading ? <div className="shimmer"></div> : (item?.company_name ? item?.company_name : 'N/A')}
                    </div>
                </td>
                <td className={styles.tablescell}>
                <div className={styles.textCell}>
                        {loading ? <div className="shimmer"></div> : (item?.created_at ? setDate(item?.created_at) : 'N/A')}
                    </div>
                </td>
                <td className={styles.tablescell}>
                    <div className={styles.textCell}>
                        {loading ? <div className="shimmer"></div> : (item?.email ? item?.email : 'N/A')}
                    </div>
                </td>
                <td className={styles.tablescell}>
                    <div className={styles.textCell}>
                        {loading ? <div className="shimmer"></div> : (item?.phone_number ? item?.phone_number : 'N/A')}
                    </div>
                </td>
                <td className={styles.tablescell}>
                    <div className={styles.textCell}>
                        {loading ? <div className="shimmer"></div> : item.user_type}
                    </div>
                </td>
                <td className={styles.tablescell}>
                {loading ? <div className="shimmer"></div> : 
                    <div className={styles.badge} style={Docstate}>
                        <div className={styles.buttonCell}>
                            {_ToNormal(item?.state ? item.state : 'NA')}
                        </div>
                    </div>}
                </td>
                <td className={styles.tablescell}>
                    {loading ? <div className="shimmer"></div> : <ButtonBase {...item} />}
                </td>
            </tr>
        {accordian == index && item.user_type === 'Issuer' ? <AccordianData Items={item?.document_with_status} onboardingStatus={item?.state} /> : <></>}
      </>
    );
  };
  return (
    <div className={tableStyles.tableBed} style={{height:"100vh"}}>
      <Loader isOpen={loading} />
      <table>
        <tr className={styles.chevronSortTableCell5}>
          <th className={styles.tablescell}>
            <div className={styles.checkbox}></div>
          </th>
          <th className={styles.tablescell}>
            <div className={styles.tableHeadText}>User</div>
          </th>
          <th className={styles.tablescell}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className={styles.tableHeadText}>Company Name</div>
            <div className={styles.dropdown} onClick={(e)=>SortList("name")}>
            <img className={styles.chevronSortIcon} alt="" src="/chevronsort.svg"/>
            </div>
            </div>
          </th>
          <th className={styles.tablescell}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className={styles.tableHeadText}>Created At</div>
            <div className={styles.dropdown} onClick={(e)=>SortList("created_at")}>
            <img className={styles.chevronSortIcon} alt="" src="/chevronsort.svg"/>
            </div>
            </div>
          </th>
          <th className={styles.tablescell}>
            <div style={{display:"flex", alignItems:"center"}}>
            <div className={styles.tableHeadText}>Email</div>
            <div className={styles.dropdown} onClick={(e)=>SortList("email")}>
              <img className={styles.chevronSortIcon} alt="" src="/chevronsort.svg"/>
            </div>
            </div>
          </th>
          <th className={styles.tablescell}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className={styles.tableHeadText}>Phone no.</div>
            <div className={styles.dropdown} onClick={(e)=>SortList("phone_no")}>
            <img className={styles.chevronSortIcon} alt="" src="/chevronsort.svg"/>
            </div>
            </div>
          </th>
          <th className={styles.tablescell}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div className={styles.tableHeadText}>Category</div>
              <div className={styles.dropdown} onClick={(e)=>SortList("category")}>
              <img className={styles.chevronSortIcon} alt="" src="/chevronsort.svg"/>
              {/* <div className={styles.dropdownContent}>
                {category.map((i,index)=>
                  <div className={styles.list} key={index}>
                    <input type="radio" className={styles.listcheckbox} style={{border:"0px"}} id={`category-${index}`} name="category" value={i} onChange={(e)=>setSelectedItems(e.target.value)}/>
                    <label htmlFor={`category-${index}`}  className={styles.modelContent}>{i}</label>
                  </div>
                )}                        
              </div> */}
              </div>
            </div>
          </th>
          <th className={styles.tablescell}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div className={styles.tableHeadText}>Status</div>
              <div className={styles.dropdown} onClick={(e)=>SortList("status")}>
              <img className={styles.chevronSortIcon} alt="" src="/chevronsort.svg"/>
              <div className={styles.dropdownContent}>
                {/* {status.map((i,index)=>(
                  <div className={styles.list} key={index}>
                    <input type="radio" value={i} className={styles.listcheckbox} id={`radio1-${index}`} name="status"/>
                    <label htmlFor={`radio1-${index}`} className={styles.modelContent} key={index}>{i}</label>
                  </div>
                )
                )}                         */}
              </div>
              </div>
            </div>
          </th>
          <th className={styles.tablescell}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div className={styles.tableHeadText}>Action</div>
              {/* <img className={styles.chevronSortIcon} alt="" src="/chevronsort.svg" /> */}
            </div>
          </th>
        </tr>
        {
        filteredItems.length==0?
        <tr>
        <td colSpan="8" className={styles.tablescell} style={{ textAlign: 'center', padding: '1rem' }}>
          <div className="Data_List">No Record Found</div>
        </td>
      </tr>
      :(filteredItems.map((i, index) => <TableData resendLink={resendLink} item={i} index={index} key={i.id} />))
        }
      </table>
    </div>
  )
}

export default UserTable;